







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Laporan from "@/services/Laporan";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { auditFieldLabel, auditFieldValue } from "@/utils/auditFieldLabel";

@Component({
  beforeRouteEnter(to, from, next) {
    if (userModule.user.role?.id <= 2) {
      next();
    } else {
      appModule.sendErrorAlert("Halaman ini tidak bisa diakses...");

      next("/404");
    }
  },
  components: {
    //
  }
})
export default class AuditTrailReportPage extends Vue {
  rptData: any = null;
  loading = false;
  options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: string[];
  } = null;
  searchStr = null;
  dates: string[] = [];
  showDate = false;
  jenisData = "soap";
  jenisDataItems = [
    { text: "SOAP (CPPT)", value: "soap" },
    { text: "Verifikasi Transfer Internal", value: "transfer_internal" }
  ];

  get objectParam(): string | null {
    return this.jenisData === "transfer_internal"
      ? "Models\\TransferInternal"
      : null;
  }

  get listItems() {
    return this.rptData
      ? this.rptData.data.map((item, index) => ({
          ...item,
          created_at: moment(item.created_at).format("YYYY-MM-DD HH:mm:ss"),
          idx: this.rptData.from + index,
          new_values: this.parseJson(item.new_values),
          old_values: this.parseJson(item.old_values)
        }))
      : [];
  }

  get listItemsTotal() {
    return this.rptData ? this.rptData.total : 0;
  }

  get headers() {
    const headers = [
      { text: "#", value: "idx" },
      { text: "IP Addr.", value: "ip_address" },
      { text: "Event", value: "event" },
      { text: "Resource ID", value: "auditable_id" },
      { text: "Old Values", value: "old_values" },
      { text: "New Values", value: "new_values" },
      { text: "Nama User", value: "user.nama" },
      { text: "Created At", value: "created_at" }
    ];

    return headers;
  }

  get dateRangeText() {
    return this.dates.join(" ~ ");
  }

  parseJson(json) {
    let html = "";
    if (typeof json === "object" && json !== null && !Array.isArray(json)) {
      for (const key in json) {
        const label = auditFieldLabel(key);
        const value = auditFieldValue(key, json[key]);
        html += `<div class="entry"><span class="label">${label}:</span> ${value}</div>`;
      }

      return html;
    } else {
      return "";
    }
  }

  @Watch("options", { deep: true })
  onChangedOptions(val) {
    this.getReportData();
  }

  onJenisDataChanged() {
    this.rptData = null;
    if (this.options && this.options.page !== 1) {
      this.options.page = 1;
    } else {
      this.getReportData();
    }
  }

  getReportData() {
    const { page, itemsPerPage, sortBy, sortDesc } = this.options;
    const params = {
      page: page,
      per_page: itemsPerPage,
      sort_by: sortBy[0],
      sort_desc: sortDesc[0],
      search: this.searchStr,
      date: this.dates,
      object: this.objectParam
    };

    if (!this.loading) {
      this.loading = true;

      Laporan.getAuditTrailReport(params)
        .then(resp => {
          this.rptData = resp;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  onRowClick(item: null) {
    // event on row click
  }
}
